export default __webpack_public_path__ + "static/media/volkihar-background-large.c441a65e.jpg";